import { BACKGROUND_FILE_SIZE, LOGO_FILE_SIZE, findJob, CustomToastrAction} from '@/imports-files/pages/clients/careers/createJob';


export function openFile()
{
  if(event.target.tagName == 'IMG')
  {
      var element = document.getElementById('file-input');
      element.click();
  }
  else
  {
      var element = document.getElementById('background-input');
      element.click();
  }
}


export function handleLogoOnChange(event,setSelectedFile)
{
  const customToastrAction  =   new CustomToastrAction(); 
  setSelectedFile(window.URL.createObjectURL(event.target.files[0]));
  check_file_size(event.target.files[0],LOGO_FILE_SIZE) ? updateLogo(event.target)
                                                        : customToastrAction.setNormalToastr('The file size is greater than 10MB', 'warning');
                                                          // toastr.warning('The file size is greater than 10MB');
  event.target.value            =   "";
  
}


export function handleBackgroundOnChange(event, setBackgroundImage)
{
  const customToastrAction  =   new CustomToastrAction(); 
  setBackgroundImage(window.URL.createObjectURL(event.target.files[0]));
  var file_path = event.target.files[0];
  check_file_size(event.target.files[0],BACKGROUND_FILE_SIZE) ? updateBackground(file_path, setBackgroundImage, event.target)
                                                              : customToastrAction.setNormalToastr('The file size is greater than 25MB', 'warning');
                                                                // toastr.warning('The file size is greater than 25MB');
  event.target.value            =   "";
}

export function set_background_image(image_url)
{
  let element =  document.getElementsByClassName('Career_Background')[0];
  if(element != undefined && (image_url?.length || 0)  > 0 )
  {
    element.style.backgroundImage.includes(image_url) ? '' : element.style.backgroundImage =  "url('"+image_url+"')";
  }
}

export function updateLogo(element)
{
  const formData = new FormData(); 
  formData.append( "career_page[logo]",  element.files[0]); 
  new findJob().setJobsImages(formData);
}

export async function updateBackground(filePath, setBackgroundImage, element)
{
  const formData = new FormData(); 
  formData.append( "career_page[bg_image]",  element.files[0]); 
  new findJob().setJobsImages(formData);
  // document.getElementsByClassName('background-image')[0].src = window.URL.createObjectURL(filePath);
}

export function updateHeader(val, setValueHeading, setHeadingEditing)
{
  if(val.trim().length > 0)
  {
    setValueHeading(val);
    let data = { career_page: {heading: val} };
    new findJob().setJobsInfo(data);
	setHeadingEditing(false)
  }
}

export function updateSubheader(val, setValueSubheading, setSubHeadingEditing)
{
  if(val.trim().length > 0)
  {
      setValueSubheading(val);
      let data = { career_page: {sub_heading: val} };
	  new findJob().setJobsInfo(data);
	  setSubHeadingEditing(false);
  }
}

function check_file_size(file,file_size)
{
  if(file.size > file_size)
  {
    return false;
  }
  else
  {
    return true;
  }
}

export async function getCustomizeCareerData(router, setApiError)
{
  const body      = { host_name: window.location.hostname, step: router.query.step };
  const job_data  =  await new findJob().getJobsDataForClientOwner(body);
  setApiError(job_data.request)
  // const data =  {
  //           props: {
  //                     job_data
  //                  }
  //        }
  return job_data.data;
}

export function removeCarrerPagePadding()
{
  
  var element = document.getElementsByClassName('CustomizeCareer')[0];

  if(element != undefined)
  {
    element.closest('.DashboardPage').style.paddingLeft = 0;
  }
  else
  {
    element = document.getElementsByClassName('DashboardPage')[0];
    if(element != undefined)
    {
      element.style.paddingLeft = null;
    }
  }
  
  var loadingElement =document.querySelector('.CustomizeCareer__LoaderInPage')
  loadingElement != undefined ? loadingElement.classList.remove('Show') : '';
}